

import React from 'react';
import _ from 'lodash';


import Skeleton, { SkeletonProps } from '@mui/material/Skeleton';

interface WithSkeletonT {
    loading?: boolean
    propsSkeleton?: SkeletonProps
}
const WithSkeleton: React.FC<WithSkeletonT> = (props) => {
    return (
        <>
            {props.loading ? <Skeleton {...props.propsSkeleton} /> : props.children}
        </>
    );
}

export default WithSkeleton
export { WithSkeleton }